import React, { Component } from 'react';
import {TableRow, TableRowColumn} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

export default class ContactNewRow extends Component {

  state = {
    contact: {
      firstName: "",
      lastName: "",
      title: "",
      phoneNumber: "",
      emailAddress: ""
    }
  }

  editValue(event, key) {
    var state = this.state;
    state.contact[key] = event.target.value;
    this.setState(state);
  }

  render() {
    let contact = this.state.contact;
    let validContact = (contact.firstName.length > 0 || contact.lastName.length > 0 || contact.title.length > 0 || contact.phoneNumber.length > 0 || contact.emailAddress.length > 0);

    return (
      <TableRow key={this.state.contact._id}>
        <TableRowColumn style={{whiteSpace:'normal'}}>
        <TextField
          hintText="Etunimi"
          value={this.state.contact.firstName}
          onChange={(event) => this.editValue(event, "firstName")}
          style={{width:"98%"}}
          />
        </TableRowColumn>
        <TableRowColumn style={{whiteSpace: 'normal'}}>
        <TextField
          hintText="Sukunimi"
          value={this.state.contact.lastName}
          onChange={(event) => this.editValue(event, "lastName")}
          style={{width:"98%"}}
          />
        </TableRowColumn>
        <TableRowColumn style={{whiteSpace:'normal'}}>
        <TextField
          hintText="Titteli"
          value={this.state.contact.title}
          onChange={(event) => this.editValue(event, "title")}
          style={{width:"98%"}}
          />
        </TableRowColumn>
        <TableRowColumn style={{whiteSpace:'normal'}}>
        <TextField
          hintText="Puhelinnumero"
          value={this.state.contact.phoneNumber}
          onChange={(event) => this.editValue(event, "phoneNumber")}
          style={{width:"98%"}}
          />
        </TableRowColumn>
        <TableRowColumn style={{whiteSpace:'normal'}}>
        <TextField
          hintText="Sähköpostiosoite"
          value={this.state.contact.emailAddress}
          onChange={(event) => this.editValue(event, "emailAddress")}
          style={{width:"98%"}}
          />
        </TableRowColumn>
        <TableRowColumn>
          <FlatButton label="Tallenna" disabled={!validContact} primary={true} onTouchTap={() => this.props.onContactSave(this.state.contact)}/>
        </TableRowColumn>
      </TableRow>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FrontPage/ContactNewRow.js